import { RouteConfig } from 'vue-router'

export const tttsPostureReportRoute: RouteConfig = {
  path: '/ai-test-ttts/posture-report',
  name: 'ai_test_ttts_posture_report',
  component: () => import('../views/ai-test-ttts/posture-report/Index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体态评测',
  },
}

export const tttsMakeTestRoute: RouteConfig = {
  path: '/ai-test-ttts/make-test',
  name: 'ai_test_ttts_make_test',
  component: () => import('../views/ai-test-ttts/make-test/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体质测试',
  },
}

export const tttsOverviewRoute: RouteConfig = {
  path: '/ai-test-ttts/overview',
  name: 'ai_test_ttts_overview',
  component: () => import('../views/ai-test-ttts/overview/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体质测试报告',
  },
}

export const tttsFitnessDetailRoute: RouteConfig = {
  path: '/ai-test-ttts/fitness-detail',
  name: 'ai_test_ttts_fitness_detail',
  component: () => import('../views/ai-test-ttts/fitness-detail/index.vue'),
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: 'AI体质测试详情',
  },
}

export default [tttsPostureReportRoute, tttsMakeTestRoute, tttsOverviewRoute, tttsFitnessDetailRoute]
